/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section2_TitleInputs */

const en_about_section2_title = /** @type {(inputs: About_Section2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why PureJSON?`)
};

const ko_about_section2_title = /** @type {(inputs: About_Section2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`왜 PureJSON인가?`)
};

const ja_about_section2_title = /** @type {(inputs: About_Section2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜPureJSON？`)
};

/**
* | output |
* | --- |
* | "Why PureJSON?" |
*
* @param {About_Section2_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section2_title = /** @type {((inputs?: About_Section2_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section2_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section2_title(inputs)
	if (locale === "ko") return ko_about_section2_title(inputs)
	return ja_about_section2_title(inputs)
});